"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinDiscountRuleSchema = exports.createFinDiscountRuleSchema = exports.finDiscountRuleShape = exports.finDiscountCalculationMethodEnum = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Discount Rules). Distinct from `pricing`'s item/drug `DiscountRule` — this is the OP-billing charge-level rule with `approvalMatrixId` reusing Platform's `ApprovalMatrix` unchanged. */
exports.finDiscountCalculationMethodEnum = zod_1.z.enum(['PERCENTAGE', 'FLAT_AMOUNT']);
exports.finDiscountRuleShape = {
    ruleCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    discountTypeId: zod_1.z.string().uuid().optional(),
    calculationMethod: exports.finDiscountCalculationMethodEnum,
    value: zod_1.z.number().int().positive(),
    maxDiscountAmount: zod_1.z.number().int().positive().optional(),
    priority: zod_1.z.number().int().min(0).optional(),
    requiresApproval: zod_1.z.boolean().optional(),
    approvalMatrixId: zod_1.z.string().uuid().optional(),
    couponCode: zod_1.z.string().min(1).max(50).optional(),
    /**
     * SCOPE — the account head this rule may discount (CONS FEE - OP for the
     * staff consultation concession). Omitted means the rule is not head-scoped,
     * and the staff-discount mechanism ignores it entirely: a rule that applied
     * to everything would fire on every line of every bill.
     */
    accountHeadId: zod_1.z.string().uuid().optional(),
    /**
     * A STAFF discount: it may only be given by naming the employee it is for.
     * The counter then supplies an EMPLOYEE and never an amount — this rule's
     * `value` is the figure, which is what makes it non-editable at the desk.
     */
    requiresEmployee: zod_1.z.boolean().optional(),
    /**
     * SCOPE, PER LINE — which service family this rule discounts.
     *
     * Desk, 2026-08-30: "first fix which is lab service, radiology service,
     * others. then each line can considerable." The staff concession is decided
     * line by line: a bill mixing a consultation with two lab tests takes the
     * flat amount on the consultation and the percentage on each test.
     *
     * Omitted means the rule is not family-scoped.
     */
    serviceFamily: zod_1.z.enum(['LAB', 'RADIOLOGY', 'OTHER']).optional(),
    /**
     * WHO the concession is for — the counter's dropdown. Omitted means EVERY
     * category, which is how one row serves staff, students, dependents,
     * retired staff and camps where the figure is the same.
     */
    beneficiaryCategory: zod_1.z.enum(['STAFF', 'STUDENT', 'DEPENDENT', 'RETIRED', 'CAMP']).optional(),
    maxRedemptions: zod_1.z.number().int().positive().optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createFinDiscountRuleSchema = zod_1.z.object(exports.finDiscountRuleShape);
exports.updateFinDiscountRuleSchema = zod_1.z.object(exports.finDiscountRuleShape).partial();
//# sourceMappingURL=fin-discount-rule.schema.js.map